import { getSubscriptions } from '@/api/marketplace'

const unwrapSubscriptionsPayload = (data: unknown) => {
    if (!data || typeof data !== 'object') return null
    const payload = data as { data?: unknown; multiSubscription?: unknown }
    if (payload.multiSubscription) return payload
    if (payload.data && typeof payload.data === 'object') {
        return payload.data as { multiSubscription?: { scheduledChanges?: unknown } | null }
    }
    return payload
}

export async function hasScheduledTariffChange(projectId?: string | number | null): Promise<boolean> {
    if (projectId == null || projectId === '') return false
    const { data, error } = await getSubscriptions(String(projectId))
    if (error) return false
    const payload = unwrapSubscriptionsPayload(data)
    return Boolean(payload?.multiSubscription && (payload.multiSubscription as { scheduledChanges?: unknown }).scheduledChanges)
}
